var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio"},[_c('audio',{attrs:{"controls":"","src":_vm.path}},[_vm._v(" "+_vm._s(_vm.$t('noEmbeddedAudioSupport.message'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }